module.exports = __webpack_public_path__ + "static/media/Thumbs.49a50062.db";